<script setup>
import { useI18n } from 'vue-i18n';

// Atalho para o Painel da IA (bridge, /painel), mostrado só a administradores
// (o painel recusa os demais); /entrar_painel_ia leva a sessão do KALL-AI até ele.
defineProps({
  isCollapsed: { type: Boolean, default: false },
});

const { t } = useI18n();
</script>

<template>
  <a
    href="/entrar_painel_ia"
    target="_blank"
    rel="noopener"
    class="flex items-center w-full gap-2 px-2 py-1.5 rounded-lg text-n-slate-11 hover:bg-n-alpha-2"
    :class="{ 'justify-center': isCollapsed }"
    :title="t('SIDEBAR.PAINEL_IA')"
  >
    <span class="flex items-center justify-center size-5">
      <span class="size-4 i-lucide-bot" />
    </span>
    <span v-if="!isCollapsed" class="text-sm truncate">
      {{ t('SIDEBAR.PAINEL_IA') }}
    </span>
    <span v-if="!isCollapsed" class="ms-auto size-3.5 i-lucide-external-link" />
  </a>
</template>
